import {
  Badge,
  type ColumnGroup,
} from '@commenda/kakashi';

import { IndirectTaxFilingsHelper } from '../helpers';
import type { ContributionLiabilityReportTableRow } from '../types';

export const CONTRIBUTION_LIABILITY_REPORT_COLUMN_GROUPS: ColumnGroup<
  ContributionLiabilityReportTableRow,
  unknown
>[] = [
    {
      id: 'liability-report-contribution',
      columns: [
        {
          accessorKey: 'jurisdiction',
          header: 'Jurisdiction',
          title: 'Jurisdiction',
          cell: ({ row }) => (
            <span className="txt-small-medium text-text-primary">
              {row.original.jurisdiction}
            </span>
          ),
        },
        {
          accessorKey: 'formTitle',
          header: 'Return',
          title: 'Return',
          enableSorting: false,
          cell: ({ row }) => (
            <span className="txt-small-regular text-text-secondary max-w-[200px] truncate block">
              {row.original.formTitle}
            </span>
          ),
        },
        {
          accessorKey: 'taxPeriodLabel',
          header: 'Tax period',
          title: 'Tax period',
          enableSorting: false,
          cell: ({ row }) => (
            <Badge variant="warning" size="sm">
              {row.original.taxPeriodLabel}
            </Badge>
          ),
        },
        {
          accessorKey: 'dueDateLabel',
          header: 'Due date',
          title: 'Due date',
          enableSorting: false,
          cell: ({ row }) => (
            <Badge variant="success" size="sm">
              {row.original.dueDateLabel}
            </Badge>
          ),
        },
        {
          accessorKey: 'amountDue',
          header: 'Amount due',
          title: 'Amount due',
          enableSorting: false,
          cell: ({ row }) => (
            <span className="txt-small-medium text-text-primary">
              <span className="txt-extra-small-regular text-text-quaternary">
                {IndirectTaxFilingsHelper.getCurrencySymbol(row.original.currency)}{' '}
              </span>
              {IndirectTaxFilingsHelper.formatCurrency(row.original.amountDue)}
            </span>
          ),
        },
        {
          accessorKey: 'filingStatusUI',
          header: 'Filing status',
          title: 'Filing status',
          enableSorting: false,
          cell: ({ row }) => {
            const config = IndirectTaxFilingsHelper.getStatusBadgeConfig(
              row.original.filingStatusUI
            );
            return (
              <Badge variant={config.variant} size="sm">
                {config.label}
              </Badge>
            );
          },
        },
      ],
    },
  ];
